"use strict";

/**
 * @module Services.ChangePrincipal
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePrincipalRequest = void 0;
/**
 * Request data for the `CHANGE_PRINCIPAL` request.
 */
var ChangePrincipalRequest = /** @class */function () {
  /**
   * Create a new SecurityCommandScriptResult
   *
   * @param principal the principal
   * @param credentials the credentials data
   */
  function ChangePrincipalRequest(principal, credentials) {
    this.principal = principal;
    this.credentials = credentials;
  }
  return ChangePrincipalRequest;
}();
exports.ChangePrincipalRequest = ChangePrincipalRequest;